const sampleProducts = [
  {
    _id: "sample-wireless-headphones",
    itemName: "Wireless Headphones",
    description: "Comfortable over-ear headphones with active noise cancellation and long battery life.",
    price: 3499
  },
  {
    _id: "sample-everyday-backpack",
    itemName: "Everyday Backpack",
    description: "A lightweight, water-resistant backpack with a padded laptop compartment.",
    price: 1899
  },
  {
    _id: "sample-ceramic-planter",
    itemName: "Ceramic Planter",
    description: "A minimal ceramic planter designed to add a calm accent to desks and shelves.",
    price: 799
  },
  {
    _id: "sample-travel-bottle",
    itemName: "Stainless Travel Bottle",
    description: "An insulated reusable bottle that keeps drinks at the right temperature for hours.",
    price: 999
  },
  {
    _id: "sample-mechanical-keyboard",
    itemName: "Mechanical Keyboard",
    description: "A compact mechanical keyboard with tactile switches and adjustable backlighting.",
    price: 4299
  },
  {
    _id: "sample-cotton-throw",
    itemName: "Cotton Throw Blanket",
    description: "A soft woven cotton throw with a neutral pattern for sofas, chairs, and beds.",
    price: 1499
  }
];

export default sampleProducts;
